<app-header></app-header>

<div class="main-container d-flex">
    <app-sidebar></app-sidebar>

    <div class="container-fluid h-100p overflow-y-scroll virtual-number-main px-2 px-sm-3 px-lg-4">
        <div class="virtual-number-page">
            <section class="vn-top-section">
                <div class="vn-title-wrap">
                    <h2 class="vn-page-title">Virtual Numbers</h2>
                    <p class="vn-page-subtitle">Receive SMS verifications across 200+ services worldwide for OSINT operations.</p>
                </div>

                <div class="credits-display">
                    <div class="credits-inline">
                        <span class="credits-inline-label">Remaining:</span>
                        <span class="credits-inline-value"><i class="fas fa-spinner fa-spin" *ngIf="creditsLoading" aria-hidden="true"></i><ng-container *ngIf="!creditsLoading">{{ availableCredits | creditsLabel }}</ng-container></span>
                    </div>
                    <button class="buy-credits-btn" (click)="onBuyCreditsButtonClick()">
                        <i class="fas fa-coins credits-icon"></i>
                        Buy Credits
                    </button>
                </div>
            </section>

            <div class="search-card-container py-2" *ngIf="isServiceDisabled">
                <div class="service-disabled-warning">
                    <div class="warning-icon">
                        <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <h2 class="warning-title">Search temporarily unavailable</h2>
                    <p class="warning-message">
                        We're experiencing a temporary service issue. Existing virtual numbers remain available below.
                    </p>
                </div>
            </div>

            <div class="restricted-alert mb-3" *ngIf="!isServiceDisabled" appRestrictedAccessWarning>
                <i class="fas fa-exclamation-circle alert-icon"></i>
                <span class="alert-text">
                    <span class="alert-restricted">RESTRICTED ACCESS</span>
                    <span class="alert-authorized">Authorized Law Enforcement Use Only</span>
                </span>
            </div>

            <section class="row g-3 vn-content-grid">
                    <div class="col-12 col-lg-8" *ngIf="!isServiceDisabled">
                        <article class="vn-card vn-buy-card">
                            <header class="vn-card-header">
                                <h5 class="mb-0">Buy a number <i class="bi bi-info-circle text-green ms-1"></i></h5>
                                <p class="mb-0">Pick a country, then choose the service you want to receive an SMS from.</p>
                            </header>

                            <div class="vn-card-body">
                                <div class="row g-0">
                                    <div class="col-12 col-md-5 vn-list-column vn-country-column">
                                        <div class="input-group mb-3 virtual-number-search-input-group">
                                            <span class="input-group-text virtual-number-icon-prefix">
                                                <i class="bi bi-search"></i>
                                            </span>
                                            <input type="text" class="form-control virtual-number-search-input" placeholder="Find country" aria-label="Find country" [(ngModel)]="searchTextCountry" (input)="filterCountries()" [disabled]="isLoadingCountries">
                                        </div>

                                        <div *ngIf="isLoadingCountries" class="text-center py-4">
                                            <div class="spinner-border text-light" role="status">
                                                <span class="visually-hidden">Loading countries...</span>
                                            </div>
                                            <p class="text-light mt-2 small mb-0">Loading countries...</p>
                                        </div>

                                        <ul class="list-group virtual-number-list-group" *ngIf="!isLoadingCountries">
                                            <li *ngFor="let country of filteredCountries; let i = index" [ngClass]="{ 'active': selectedCountry?.id === country.id }" (click)="!isLoadingServices && updateCountry(country)" [style.cursor]="isLoadingServices ? 'not-allowed' : 'pointer'" [style.opacity]="isLoadingServices ? '0.6' : '1'" class="list-group-item virtual-number-list-item d-flex justify-content-between align-items-center">
                                                <span class="d-flex align-items-center text-truncate">
                                                    <img src="https://flagcdn.com/w20/{{country.iso}}.png" alt="{{country.name}}" class="flag-icon me-2">
                                                    {{country.name}}
                                                </span>
                                                <span class="text-green ms-2">+{{country.code}}</span>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="col-12 col-md-7 vn-list-column">
                                        <div class="input-group mb-3 virtual-number-search-input-group">
                                            <span class="input-group-text virtual-number-icon-prefix">
                                                <i class="bi bi-search"></i>
                                            </span>
                                            <input type="text" class="form-control virtual-number-search-input" placeholder="Find a site" aria-label="Find a site" [(ngModel)]="searchTextService" (input)="filterServices()" [disabled]="isLoadingServices">
                                        </div>

                                        <div *ngIf="isLoadingServices" class="text-center py-4">
                                            <div class="spinner-border text-light" role="status">
                                                <span class="visually-hidden">Loading services...</span>
                                            </div>
                                            <p class="text-light mt-2 small mb-0">Loading services...</p>
                                        </div>

                                        <div *ngIf="!isLoadingServices && !selectedCountry" class="text-center py-4">
                                            <i class="bi bi-arrow-left text-light" style="font-size: 2rem;"></i>
                                            <p class="text-light mt-2 mb-0">Please select a country first</p>
                                        </div>

                                        <ul class="list-group virtual-number-list-group" *ngIf="!isLoadingServices && selectedCountry">
                                            <li *ngFor="let service of filteredServices; let i = index;" [ngClass]="{ 'active': selectedService === i }" (click)="!isLoadingPurchase && purchaseNumber(service)" [style.cursor]="isLoadingPurchase ? 'not-allowed' : 'pointer'" [style.opacity]="isLoadingPurchase ? '0.6' : '1'" class="list-group-item virtual-number-list-item d-flex justify-content-between align-items-center">
                                                <span class="d-flex align-items-center text-truncate">
                                                    <img [src]="'https://cdn.simpleicons.org/' + service.name" alt="{{service.name}}" class="service-icon me-2 rounded-circle" (error)="onImgError($event, service)">
                                                    {{service.name}}
                                                </span>
                                                <div class="d-flex align-items-center">
                                                    <span class="me-2">{{service.availability}}</span>
                                                    <span class="badge virtual-number-price-badge">{{service.credit_cost}} Cdt</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>

                    <div class="col-12" [ngClass]="isServiceDisabled ? 'col-lg-12' : 'col-lg-4'">
                        <article class="vn-card vn-my-numbers-card">
                            <header class="vn-card-header vn-my-numbers-header">
                                <h5 class="mb-0">My numbers <i class="bi bi-info-circle text-green ms-1"></i></h5>
                            </header>

                            <div class="vn-card-body d-flex flex-column align-items-center justify-content-center" *ngIf="isLoadingPurchase">
                                <div class="spinner-border text-secondary mb-3" role="status">
                                    <span class="visually-hidden">Purchasing number...</span>
                                </div>
                                <p class="text-secondary mb-0">Generating virtual number...</p>
                            </div>

                            <div class="vn-card-body" *ngIf="purchasedNumber != null && !isLoadingPurchase">
                                <div class="virtual-number-my-number-item p-3 mb-3">
                                    <div class="d-flex justify-content-between align-items-start mb-2">
                                        <h6 class="mb-0 d-flex align-items-center">
                                            <img src="https://flagcdn.com/w20/{{purchasedNumber.country.iso}}.png" alt="{{purchasedNumber.country.name}}" class="flag-icon me-2">
                                            {{purchasedNumber.phone_number}}
                                            <i class="bi bi-copy ms-2 copy-icon" (click)="copyPhoneNumber()" title="Copy phone number"></i>
                                        </h6>
                                        <div class="d-flex align-items-center">
                                            <span class="text-warning me-2">{{expiryTime}}</span>
                                            <button (click)="cancelNumber()" class="btn btn-sm btn-danger virtual-number-delete-button text-dblack" [disabled]="isLoadingCancel">
                                                <span *ngIf="!isLoadingCancel">X</span>
                                                <span *ngIf="isLoadingCancel" class="spinner-border spinner-border-sm" role="status"></span>
                                            </button>
                                        </div>
                                    </div>
                                    <p class="mb-1 text-success small">Number is ready to receive SMS</p>
                                </div>

                                <div class="virtual-number-my-number-item p-3 mb-3 text-center" *ngIf="isLoadingMessages && messages.length === 0">
                                    <div class="spinner-border text-secondary spinner-border-sm mb-2" role="status">
                                        <span class="visually-hidden">Waiting for messages...</span>
                                    </div>
                                    <p class="text-muted small mb-0">Waiting for SMS...</p>
                                </div>

                                <div class="virtual-number-my-number-item p-3" *ngFor="let message of messages">
                                    <h6 class="mb-2 d-flex align-items-center">
                                        <img [src]="'https://cdn.simpleicons.org/' + selectedService.name" (error)="onImgError($event, selectedService)" alt="{{selectedService.name}}" class="service-icon me-2 rounded-circle">
                                        {{selectedService.name}}
                                    </h6>
                                    <p class="text-muted small mb-0">Your OTP for {{selectedService.name}} is <b>{{message.message_text}}</b></p>
                                </div>
                            </div>

                            <div class="vn-card-body d-flex flex-column align-items-center justify-content-center" *ngIf="purchasedNumber == null && !isLoadingPurchase">
                                <i class="fa fa-info-circle fs-1 mb-3"></i>
                                <p class="text-secondary mb-0">Virtual Number is not Generated</p>
                            </div>
                        </article>
                    </div>
                </section>
            </div>
        </div>
    </div>